import { h, Fragment } from "preact";

import { Alert, Box, Collapse, IconButton, Typography } from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";

export default function CollapseInfos({ collapse, setCollapse }) {
	if (!collapse.open) return;
	return (
		<div style="margin-bottom: 10px">
			<Collapse in={collapse.open}>
				<Alert
					icon={collapse.icon ? collapse.icon : false}
					action={
						<Box flexDirection="column" display="flex" alignItems="center" justifyContent="center" style="height: 100%">
							{collapse.actions ? <Box>{collapse.actions}</Box> : null}
							{collapse.noclose === undefined ? (
								<Box>
									<IconButton
										aria-label="close"
										color="inherit"
										size="small"
										onClick={() => {
											setCollapse({ open: false, mess: "" });
										}}
									>
										<CloseIcon fontSize="inherit" />
									</IconButton>
								</Box>
							) : (
								""
							)}
						</Box>
					}
					severity={collapse.severity ? collapse.severity : "warning"}
				>
					{collapse.mess}
				</Alert>
			</Collapse>
		</div>
	);
}
